export default __webpack_public_path__ + "static/media/substorms_icon.5e319fa2.svg";